import { makeStyles } from '@material-ui/core/styles';

export default makeStyles({
    footer: {
        padding: '2%',
    },
})